<div class="checkout-journey-collector-settings">
  <div class="page-header">
    <div class="page-title">Checkout Journey</div>
    <p class="page-description">
      Liga ou desliga a persistência do coletor
      <code>POST /open/checkout-journey/events</code> na subscription-api. Quando
      desligado, a API responde <strong>200</strong> sem gravar no banco
      Subscription e <strong>não bloqueia</strong> o checkout.
    </p>
    <div class="fallback-note">
      <i class="pi pi-info-circle"></i>
      <span>
        Independente do kill-switch do Firestore no front. A alteração só vale
        depois de clicar em Salvar.
      </span>
    </div>
  </div>

  @if (config) {
    <div class="config-card">
      <div class="config-card__header">
        <div>
          <h2>Coletor de telemetria</h2>
          <p>
            Flag operacional em
            <code>CheckoutJourneyCollectorConfig</code> (B4A.Setup).
          </p>
        </div>
      </div>

      <div class="toggle-row">
        <div class="toggle-row__copy">
          <strong>{{ config.name }}</strong>
          <small>{{ config.description }}</small>
        </div>
        <p-inputSwitch [formControl]="enabledControl" [disabled]="saving" />
      </div>

      <div class="config-card__footer">
        <small class="config-card__updated">
          @if (config.dateUpdated) {
            <i class="pi pi-clock"></i>
            Última atualização:
            {{ config.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
            @if (config.updatedBy) {
              <span> por {{ config.updatedBy }}</span>
            }
          }
        </small>
        <p-button
          label="Salvar"
          icon="pi pi-check"
          (onClick)="save()"
          [loading]="saving"
          [disabled]="saving || !dirty"
        />
      </div>
    </div>
  }
</div>
<p-toast />
